import { createSlice } from "@reduxjs/toolkit";
import verifyStudyLink from "@custom/rtk-apis/media-service/verifyStudyLink";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const verifyStudyLinkSlice = createSlice({
  name: "verifyStudyLinkSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(verifyStudyLink.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(verifyStudyLink.fulfilled, (state, { payload }) => {
        console.log("Fulfilled for verify study  slice",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.error=''
      })
      .addCase(verifyStudyLink.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
      });
  },
});

export default verifyStudyLinkSlice.reducer;
